Vue.component('review-stars', {
    props: ['reviewSummary'],
    computed: {
        reviewClass: function () {
            if (this.reviewSummary && this.reviewSummary.averageRating > 0) {
                var reviewRankClass = 'reviewRank' + (Math.round(this.reviewSummary.averageRating * 2) / 2);
                return reviewRankClass.replace('.', '-');
            } else {
                return '';
            }
        }
    },
    template:
        '<div class="stars-flat" v-if="reviewSummary && reviewSummary.totalReviews > 0 && reviewSummary.averageRating > 0">' +
            '<div v-bind:class="[\'starsFull\', reviewClass]"></div>' +
            '<div class="starsEmpty"></div>' +
        '</div>'
});